import { PageContainer } from "@toolpad/core/PageContainer";

import Paper from "@mui/material/Paper";
import SystemContent from "./SystemContent";

export default function SystemValues() {
  return (
    <Paper sx={{ width: "100%" }}>
      <PageContainer>
        <SystemContent />
      </PageContainer>
    </Paper>
  );
}
